import type { Lead } from '../types';

type Answers = Record<string, any>;

export function parseLeadAnswers(raw: Lead['raw_answers']): Answers {
  if (!raw) return {};
  try {
    const value = JSON.parse(raw);
    return value && typeof value === 'object' ? value as Answers : {};
  } catch {
    return {};
  }
}

function formKind(lead: Lead, answers: Answers) {
  return String(answers.form_kind || answers.source_detail || '').trim().toLowerCase();
}

export function isMapLead(lead: Lead) {
  if (String(lead.source).toLowerCase() !== 'website') return false;
  const kind = formKind(lead, parseLeadAnswers(lead.raw_answers));
  return kind.startsWith('map_') || kind === 'payment';
}

export function isMapConsultationLead(lead: Lead) {
  const answers = parseLeadAnswers(lead.raw_answers);
  const kind = formKind(lead, answers);
  return isMapLead(lead) && (kind === 'map_consultation' || answers.form_data?.action === 'consultation');
}

export function mapLeadDetails(lead: Lead) {
  const answers = parseLeadAnswers(lead.raw_answers);
  const formData = answers.form_data && typeof answers.form_data === 'object' ? answers.form_data : {};
  return {
    centre: String(answers.location || answers.center || formData.location || lead.clinic_tag || '').trim(),
    preferredWindow: String(formData.preferred_window || answers.preferred_window || '').trim(),
  };
}

export function hasVerifiedPayment(lead: Lead) {
  return Number(lead.verified_payment_amount_minor || 0) > 0;
}
